import { getLocale } from "../runtime";

const sv_trackorderbutton = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Spåra order`
};

const trackorderbutton = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "sv") return sv_trackorderbutton(inputs)
	return "trackOrderButton";
};

export { trackorderbutton as "trackOrderButton" };